<div class="p-4 text-center">
  <div class="mb-3">
    <ng-container *ngIf="data?.type == 'warning'; else isDelete">
      <img *ngIf="imgUrl != 'warning'" width="70px" src='./../../../../assets/images/success-check.svg' alt="">
      <img *ngIf="imgUrl == 'warning'" width="70px" src="./../../../../assets/images/warning-conform-icon.svg" alt="">
    </ng-container>
    <ng-template #isDelete>
      <img width="70px" src="./../../../../assets/images/delete_icon.svg" alt="">
    </ng-template>
  </div>
  <ng-container *ngIf="data?.type == 'warning'; else isDeleteTitle">
    <div class="outline-border-text mb-2">{{data.title}}</div>
  </ng-container>
  <ng-template #isDeleteTitle>
    <div class="outline-border-text mb-2">{{data.title}}</div>
  </ng-template>

  <div *ngIf="data?.type !== 'warning'" class="font-color-gray mb-4 d-flex align-items-center justify-content-center"
    [innerHTML]="formatMessage(data.message? data.message:'')"></div>
  <div *ngIf="data?.type == 'warning'" class="mb-4 d-flex align-items-center justify-content-center"
    [innerHTML]="formatMessage(data.message? data.message:'')"></div>

  <button [ngClass]="{
    'btn-warning': data.type === 'warning' && imgUrl == 'warning',
    'btn-success': data.type === 'warning' && imgUrl != 'warning',
    'btn-danger': data.type !== 'warning'
  }" [mat-dialog-close]="true">
    {{ data.confirmCaption }}
  </button>

  <button class="btn-white-border ms-2" [mat-dialog-close]="false">
    {{data.cancelCaption}}
  </button>
</div>